const MoneyTest = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;

const comdify = function (n) {
  if(n === '' || n === null || n === undefined) return n;
  let str = n.toString().split('.');
  let re = /\d{1,3}(?=(\d{3})+$)/g;
  let n1 = str[0].replace(re, "$&,");
  return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
};

//去除千分位中的‘，'
const delcommafy = function (num){
  if(!num) return num;
  num = num.toString();
  num = num.replace(/,/gi, '');
  return num;
};

const valdateFn = function (rule,val,cb) {
  setTimeout(() => {
    if(val) {
      let inputVal = delcommafy(val);
      if (rule.test(inputVal)) {
        cb()
      } else {
        cb('只能是数字金额,最多两位小数')
      }
    }
    cb()
  })
}

// 验证金额数字可以为负数
const moneyValid = function (rule,val,cb) {
  valdateFn(/((^-?[1-9]\d*)|^-?0)(\.\d{0,2}){0,1}$/,val,cb);
};

// 验证金额数字不可以为负数
const moneyNValid = function (rule,val,cb) {
  valdateFn(MoneyTest,val,cb);
};

// 获取输入框的值
const getInputValue = function (el) {
  let inputVal = el.target.value || '';
  return comdify(delcommafy(inputVal));
};

/* ---------------- 工作流金额字段：千分位 / 人民币大写 ---------------- */

// 金额输入过滤：仅保留数字、最多一个小数点（最多两位小数）与前置负号
const sanitizeMoney = function (raw) {
  if (raw === '' || raw === null || raw === undefined) return '';
  let s = String(raw).replace(/[^\d.\-]/g, '');
  const neg = s.charAt(0) === '-';
  s = s.replace(/-/g, '');
  const dot = s.indexOf('.');
  if (dot >= 0) {
    s = s.slice(0, dot + 1) + s.slice(dot + 1).replace(/\./g, '').slice(0, 2);
  }
  return (neg ? '-' : '') + s;
};

// 金额输入实时格式化：过滤 + 整数部分千分位（纯函数，可直接作为 uView u-input 的 formatter）
const moneyInputFormatter = function (raw) {
  const s = sanitizeMoney(raw);
  if (s === '') return '';
  const neg = s.charAt(0) === '-';
  const body = neg ? s.slice(1) : s;
  const dot = body.indexOf('.');
  const intStr = dot >= 0 ? body.slice(0, dot) : body;
  const decStr = dot >= 0 ? body.slice(dot) : '';
  return (neg ? '-' : '') + intStr.replace(/\B(?=(\d{3})+$)/g, ',') + decStr;
};

// 数字金额转千分位文本，默认保留两位小数
const formatMoney = function (n, decimals) {
  if (n === '' || n === null || n === undefined) return '';
  const num = Number(delcommafy(n));
  if (isNaN(num)) return '';
  const d = decimals === undefined ? 2 : decimals;
  const fixed = Math.abs(num).toFixed(d);
  const parts = fixed.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+$)/g, ',');
  return (num < 0 ? '-' : '') + parts.join('.');
};

// 去千分位后的金额文本转数字，空值/非法值返回 ''
const toMoneyNumber = function (val) {
  if (val === '' || val === null || val === undefined) return '';
  const s = delcommafy(val);
  if (s === '' || s === '-' || s === '.' || s === '-.') return '';
  const n = Number(s);
  return isNaN(n) ? '' : n;
};

// 数字金额转人民币大写，如 1234.56 -> 壹仟贰佰叁拾肆元伍角陆分
const toChineseAmount = function (money) {
  if (money === '' || money === null || money === undefined) return '';
  const num = Number(delcommafy(money));
  if (isNaN(num)) return '';

  const HEAD = num < 0 ? '负' : '';
  const totalFen = Math.round(Math.abs(num) * 100); // 先转“分”，规避浮点误差
  if (totalFen === 0) return '零元整';

  const intPart = Math.floor(totalFen / 100);
  const jiao = Math.floor((totalFen % 100) / 10);
  const fen = totalFen % 10;

  const CN_NUM = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const CN_UNIT = ['', '拾', '佰', '仟'];
  const CN_GROUP = ['', '万', '亿', '万亿'];

  // 整数部分按四位分组转大写
  let intCn = '';
  if (intPart > 0) {
    const groups = [];
    let rest = String(intPart);
    while (rest.length > 0) {
      groups.unshift(rest.slice(-4));
      rest = rest.slice(0, -4);
    }
    groups.forEach((g, gi) => {
      const unitIdx = groups.length - 1 - gi;
      let gCn = '';
      let hasNonZero = false;
      for (let i = 0; i < g.length; i++) {
        const d = Number(g[i]);
        const pos = g.length - 1 - i;
        if (d === 0) {
          if (hasNonZero && !gCn.endsWith(CN_NUM[0])) gCn += CN_NUM[0];
        } else {
          hasNonZero = true;
          gCn += CN_NUM[d] + CN_UNIT[pos];
        }
      }
      // 整组为零：后接非零组时由该组负责补零
      if (!hasNonZero) return;
      gCn = gCn.replace(/零+$/, '');
      // 高位组补零：如 1 0001 -> 壹万零壹
      if (intCn && Number(g[0]) === 0 && !intCn.endsWith(CN_NUM[0])) intCn += CN_NUM[0];
      intCn += gCn + CN_GROUP[unitIdx];
    });
  }

  // 小数部分
  let decCn = '';
  if (jiao > 0) {
    decCn += CN_NUM[jiao] + '角';
    if (fen > 0) decCn += CN_NUM[fen] + '分';
  } else if (fen > 0) {
    decCn += (intCn ? CN_NUM[0] : '') + CN_NUM[fen] + '分';
  }

  if (!intCn) return HEAD + (decCn ? CN_NUM[0] + '元' + decCn : '零元整');
  return HEAD + intCn + '元' + (decCn || '整');
};

export {
	comdify,
	getInputValue,
	delcommafy,
	sanitizeMoney,
	moneyInputFormatter,
	formatMoney,
	toMoneyNumber,
	toChineseAmount
};

